import {XHTTP} from '@/shared/xhttp';
import {CommandeService} from "@/xhttp";
import {Pile, Transporteur} from "@/models";
import {DateHelper} from "@/shared/utils";
import {BoisType} from "@/models/BoisType";
import {LongueursVente} from "@/models/LongueursVente";
import {Client} from "@/models/Client";

@XHTTP(CommandeService, '/commandes')
export class Commande {

	private _id: number;
	private _date: Date = new Date();
	private _numberTrucks: number;
	private _remainingTrucks: number;
	private _client: Client;
	private _plannedWeek: string;
	private _boisType: BoisType;
	private _longueursVente: LongueursVente;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get allName(): string {
		return this._client.name + ' | ' + this._boisType.name + ' | ' + this._longueursVente.name;
	}

	public get numberTrucks(): number {
		return this._numberTrucks;
	}

	public get remainingTrucks(): number {
		return this._remainingTrucks;
	}

	public get client(): Client {
		return this._client;
	}

	public get plannedWeek(): string {
		return this._plannedWeek;
	}

	public get boisType(): BoisType {
		return this._boisType;
	}

	public get longueursVente(): LongueursVente {
		return this._longueursVente;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: Date) {
		this._date = value;
	}

	public set numberTrucks(value: number) {
		this._numberTrucks = value;
	}

	public set remainingTrucks(value: number) {
		this._remainingTrucks = value;
	}

	public set client(value: Client) {
		this._client = value;
	}

	public set plannedWeek(value: string) {
		this._plannedWeek = value;
	}

	public set boisType(value: BoisType) {
		this._boisType = value;
	}

	public set longueursVente(value: LongueursVente) {
		this._longueursVente = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id       : this._id,
			date    : this._date ? DateHelper.toLocalizedString(this._date) : null,
			numberTrucks : this._numberTrucks,
			remainingTrucks : this._remainingTrucks,
			client  : this._client ? this._client.id : null,
			plannedWeek : this._plannedWeek,
			boisType : this._boisType,
			longueursVente : this._longueursVente,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._numberTrucks  = data.numberTrucks;
		this._remainingTrucks  = data.remainingTrucks;
		this._client   = data.client ? (new Client()).fromJSON(data.client) : null;
		this._plannedWeek  = data.plannedWeek;
		this._boisType   = data.boisType ? (new BoisType()).fromJSON(data.boisType) : null;
		this._longueursVente   = data.longueursVente ? (new LongueursVente()).fromJSON(data.longueursVente) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}